import { BrowserRouter } from "react-router-dom";
import { BaseRoutes } from "./app/routes";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { EnumsProvider } from "./context/EnumsContext";
import './locales/i18n'
function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <EnumsProvider>
          <BrowserRouter>
            <BaseRoutes />
          </BrowserRouter>
        </EnumsProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;